var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86665 15.9035L3.84426 9.01845H0.915527V6.06772H3.84426V4.10057C3.84426 1.4457 5.47606 0.16626 7.82673 0.16626C8.95272 0.16626 9.92047 0.25072 10.2025 0.288469V3.06296L8.57217 3.06371C7.29375 3.06371 7.04622 3.67576 7.04622 4.5739V6.06772H10.678L9.70173 9.01845H7.04621V15.9035H3.86665Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.71bbf0ede782573492555577f4af3789.svg";
export { ForwardRef as ReactComponent };